@if (show) {
<div class="cx-product-layout" (click)="changeMode()">
  <div [ngClass]="buttonClass">
    @if (viewMode === iconTypes.LIST) {
    <mat-icon
      matTooltip="{{ 'buttonTooltip.plp.listViewButton' | cxTranslate }}"
      [matTooltipPosition]="'below'"
      matTooltipClass="icon-tooltip-plp-view "
      svgIcon="list-icon"
    ></mat-icon>
    } @if (viewMode === iconTypes.GRID) {
    <mat-icon
      matTooltip="{{ 'buttonTooltip.plp.gridViewButton' | cxTranslate }}"
      [matTooltipPosition]="'below'"
      matTooltipClass="icon-tooltip-plp-view"
      aria-label="displays a tooltip in bottom"
      svgIcon="grid-icon"
    ></mat-icon>
    }
  </div>
</div>
}
